import React from 'react';
import './Email.css';

export const Email = ({ email }) => {
    const { from, to, subject, timestamp, status, body } = email;
    
    return (
        <div className="email-container">
            <div className="email-header">
                <div className="email-header-top">
                    <div className="email-subject">{subject}</div>
                    {timestamp && <div className="email-timestamp">{timestamp}</div>}
                </div>
                <div className="email-metadata">
                    <div className="email-from">
                        <span className="email-label">From:</span> {from}
                    </div>
                    <div className="email-to">
                        <span className="email-label">To:</span> {to}
                    </div>
                    {status && (
                        <div className="email-status">
                            <span className="email-label">Status:</span> {status}
                        </div>
                    )}
                </div>
            </div>
            <div className="email-body">
                {body.split('\n').map((line, i) => (
                    <p key={i}>{line}</p>
                ))}
            </div>
        </div>
    );
}; 